/**
 * Setup the modal
 * @param id DOM element id
 */
 var PrescriptionModal = function (id) {
    if (!id) return;
  
    // link properties for easy access
    this.id = id;
    this.modal = document.getElementById(id);
    this.style = this.modal.style;
  
    /** predefined css styles @see PrescriptionModal::applyStyle() */
    this.styleDefinition = {
      visible: {
        opacity: 1,
        transform: 'scale(1)',
        pointerEvents: 'all',
      },
      hidden: {
        opacity: 0,
        transform: 'scale(0)',
        pointerEvents: 'none',
      },
    };
  
    this.setup();
  };
  
  /**
   * Applies the given style object to te modals CSS style
   * @param style @see this.styleDefinition
   */
  PrescriptionModal.prototype.applyStyle = function (style) {
    // transition via classList won't work
    Object.assign(this.style, style);
  };
  
  /**
   * EventHandler for the "need help" button
   */
  PrescriptionModal.prototype.onOpenClick = function () {
    this.applyStyle(this.styleDefinition.visible);
  };
  
  /**
   * EventHandler for the "close" button
   */
  PrescriptionModal.prototype.onCloseClick = function () {
    this.applyStyle(this.styleDefinition.hidden);
  };
  
  /**
   * Queries the element for the appropriate button
   * @param type "open" | "close"
   * @returns DOMElement
   */
  PrescriptionModal.prototype.getButton = function (type) {
    return document.querySelector('button.help-modal__' + type + '[data-modal="' + this.id + '"]');
  };
  
  /**
   * Attach the event handlers to the buttons
   */
  PrescriptionModal.prototype.setup = function () {
    // open action
    var buttonOpen = this.getButton('open');
  
    // the surrounding div is actually the button..
    buttonOpen = buttonOpen.parentElement;
    buttonOpen.addEventListener('click', this.onOpenClick.bind(this));
  
    // close action
    var buttonClose = this.getButton('close');
    buttonClose.addEventListener('click', this.onCloseClick.bind(this));
  };
  